import { ChangeEventHandler, useCallback, useMemo, useRef } from 'react';
import { Select } from '@glu/form-components';
import locale from '@glu/locale';
import { updateOptions } from './utils';
import useStyles from './PageDisplayCount.styles';
import { IPaginationProps } from '../Pagination/Pagination';

export const baseOptions = [5, 10, 25, 50, 100, 250];

interface IPageDisplayCountProps {
  onChange: IPaginationProps['onPageSizeChange'];
  pageSize: IPaginationProps['pageSize'];
  pageSizeOptions: IPaginationProps['pageSizeOptions'];
}

function PageDisplayCount({
  onChange,
  pageSize,
  pageSizeOptions = baseOptions,
}: IPageDisplayCountProps) {
  // Preserve the original custom pageSize
  const pageSizeOriginal = useRef(pageSize);
  const classes = useStyles();
  const options = useMemo(
    () =>
      updateOptions({
        options: pageSizeOptions,
        originalPageSize: pageSizeOriginal.current,
      }),
    [pageSizeOptions]
  );

  const onChangeCallback = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (e) => {
      e.preventDefault();
      const newValue = parseInt(e.target.value, 10);
      onChange(newValue);
    },
    [onChange]
  );
  return (
    <div className={classes.countWrapper}>
      <Select
        disableInputAPI
        inline
        labelText={locale.get('dataComponents.display')}
        name="pageDisplay"
        onChange={onChangeCallback}
        options={options}
        value={pageSize}
      />
    </div>
  );
}

export default PageDisplayCount;
